import React from 'react';

class VMovCorrTable extends React.Component {

    data(dt) {

        let vec = dt.split("-");
        let dia = vec[2];
        let mes = vec[1];
        let ano = vec[0];

        return dia + " / " + mes + " / " + ano;

    }

    ghg(g) {
        if (g) return "Sim";
        else return "Não";
    }

    render() {
        return(
            <div>
                <p className={ "vismov-cad-corr" }>
                    <b>Corrigido por: </b> { this.props.corrigidoPorNome }
                </p><br />
                <p Style={ "font-family: 'Arial'; font-size: 16px; color: #666666; float: left; margin-right: 20px;" }>
                    <b>Legenda:</b>
                </p>
                <table Style={ "margin-top: -4px; border-collapse: collapse; width: 650px; font-family: 'Arial'; font-size: 16px; color: #666666;" }>
                    <tbody>
                        <tr Style={ "height: 25px;" }>
                            <td Style={ "border: 1px solid #666666; padding-left: 10px;" }>
                                Correto
                            </td>
                            <td Style={ "border: 1px solid #666666; padding-left: 10px; background: #ddeeff" }>
                                Editado
                            </td>
                            <td Style={ "border: 1px solid #666666; padding-left: 10px; background: #ffff00;" }>
                                Erro Simples
                            </td>
                            <td Style={ "border: 1px solid #666666; padding-left: 10px; background: #ffff00; color: #ff0000;" }>
                                Erro Grave
                            </td>
                            <td Style={ "border: 1px solid #666666; padding-left: 10px; background: #ff6666; color: #ffffff;" }>
                                Modificado após a aprovação/correção
                            </td>
                        </tr>
                    </tbody>
                </table><br /><br />
                <table id="visualizar-movimentacao-table-corr">
                    <thead>
                        <tr>
                            <th></th>
                            <th></th>
                            <th>Correções</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className={ "vismov-td-corr-" + this.props.errGhg }>
                                <b>GHG:</b>
                            </td>
                            <td className={ "vismov-td-corr-" + this.props.errGhg }>
                                <span>{ this.ghg(this.props.ghg) }</span>
                            </td>
                            <td>
                                <span>
                                    { (this.props.errGhg === 1 || this.props.errGhg === 2 || this.props.errGhg === 4) && 
                                        this.ghg(this.props.corrGhg) }
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <td className={ "vismov-td-corr-" + this.props.errData }>
                                <b>Data:</b>
                            </td>
                            <td className={ "vismov-td-corr-" + this.props.errData }>
                                <span>{ this.data(this.props.data) }</span>
                            </td>
                            <td>
                                <span>
                                    { (this.props.errData === 1 || this.props.errData === 2 || this.props.errData === 4) &&
                                        this.data(this.props.corrData) }
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <td className={ "vismov-td-corr-" + this.props.errBanco }>
                                <b>Banco:</b>
                            </td>
                            <td className={ "vismov-td-corr-" + this.props.errBanco }>
                                <span>{ this.props.bancoNome }</span>
                            </td>
                            <td>
                                <span>{ this.props.corrBancoNome }</span>
                            </td>
                        </tr>
                        <tr>
                            <td className={ "vismov-td-corr-" + this.props.errContaId }>
                                <b>Conta:</b>
                            </td>
                            <td className={ "vismov-td-corr-" + this.props.errContaId }>
                                <span>{ this.props.conta }</span>
                            </td>
                            <td>
                                <span>{ this.props.corrConta }</span>
                            </td>
                        </tr>
                        <tr>
                            <td className={ "vismov-td-corr-" + this.props.errContaId }>
                                <b>Código da Conta:</b>
                            </td>
                            <td className={ "vismov-td-corr-" + this.props.errContaId }>
                                <span>{ this.props.codConta }</span>
                            </td>
                            <td>
                                <span>{ this.props.corrCodConta }</span>
                            </td>
                        </tr>
                        <tr>
                            <td className={ "vismov-td-corr-" + this.props.errContaId }>
                                <b>Código da Movimentação:</b>
                            </td>
                            <td className={ "vismov-td-corr-" + this.props.errContaId }>
                                <span>{ this.props.codMovimentacao }</span>
                            </td>
                            <td>
                                <span>{ this.props.corrCodMovimentacao }</span>
                            </td>
                        </tr>
                        <tr>
                            <td className={ "vismov-td-corr-" + this.props.errHistorico }>
                                <b>Histórico:</b>
                            </td>
                            <td className={ "vismov-td-corr-" + this.props.errHistorico }>
                                <span>{ this.props.historico }</span>
                            </td>
                            <td>
                                <span>{ this.props.corrHistorico }</span>
                            </td>
                        </tr>
                        <tr>
                            <td className={ "vismov-td-corr-" + this.props.errDescricao }>
                                <b>Descrição da Movimentação:</b>
                            </td>
                            <td className={ "vismov-td-corr-" + this.props.errDescricao }>
                                <span>{ this.props.descricao }</span>
                            </td>
                            <td>
                                <span>{ this.props.corrDescricao }</span>
                            </td>
                        </tr>
                        <tr>
                            <td className={ "vismov-td-corr-" + this.props.errValor }>
                                <b>Valor:</b>
                            </td>
                            <td className={ "vismov-td-corr-" + this.props.errValor }>
                                <span>{ "R$ " + this.props.valor }</span>
                            </td>
                            <td>
                                <span>
                                    { (this.props.errValor === 1 || this.props.errValor === 2 || this.props.errValor === 4)
                                        && "R$ " }
                                    { this.props.corrValor }
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <td className={ "vismov-td-corr-" + this.props.errNotaFiscal }>
                                <b>Documento Fiscal:</b>
                            </td>
                            <td className={ "vismov-td-corr-" + this.props.errNotaFiscal }>
                                <p className={ "vismov-download-nf" }
                                    onClick={ this.props.downloadNotaFiscal }>
                                    <span>{ this.props.notaFiscal }</span>
                                </p>
                            </td>
                            <td>
                                { ((this.props.errNotaFiscal !== 0 && this.props.errNotaFiscal !== 3 && this.props.errNotaFiscal !== null)
                                    && (this.props.corrNotaFiscal === null || this.props.corrNotaFiscal === "")) &&
                                    <button className={ "vismov-anexar-correcao-btn" }
                                        onClick={ this.props.anexarNotaCorrigida }>
                                        Anexar Correção
                                    </button> }
                                { ((this.props.errNotaFiscal !== 0 && this.props.errNotaFiscal !== 3)
                                    && (this.props.corrNotaFiscal !== null && this.props.corrNotaFiscal !== "")) &&
                                    <p className={ "vismov-download-nf" }
                                        onClick={ this.props.downloadCorrNotaFiscal }>
                                        <span>{ this.props.corrNotaFiscal }</span>
                                    </p> }
                            </td>
                        </tr>
                        <tr>
                            <td className={ "vismov-td-corr-" + this.props.errComprovante }>
                                <b>Comprovante de Pagamento:</b>
                            </td>
                            <td className={ "vismov-td-corr-" + this.props.errComprovante }>
                                <p className={ "vismov-download-nf" }
                                    onClick={ this.props.downloadComprovante }>
                                    <span>{ this.props.comprovante }</span>
                                </p>
                            </td>
                            <td>
                                { ((this.props.errComprovante !== 0 && this.props.errComprovante !== 3 && this.props.errComprovante !== null)
                                    && (this.props.corrComprovante === null || this.props.corrComprovante === "")) &&
                                    <button className={ "vismov-anexar-correcao-btn" }
                                        onClick={ this.props.anexarComprovanteCorrigido }>
                                        Anexar Correção
                                    </button> }
                                { ((this.props.errComprovante !== 0 && this.props.errComprovante !== 3)
                                    && (this.props.corrComprovante !== null && this.props.corrComprovante !== "")) &&
                                    <p className={ "vismov-download-nf" }
                                        onClick={ this.props.downloadCorrComprovante }>
                                        <span>{ this.props.corrComprovante }</span>
                                    </p> }
                            </td>
                        </tr>
                        <tr>
                            <td className={ "vismov-td-corr-" + this.props.errAnaliseContabil }>
                                <b>Análise Contábil:</b>
                            </td>
                            <td className={ "vismov-td-corr-" + this.props.errAnaliseContabil }>
                                <span>{ this.props.descricao }</span>
                            </td>
                            <td>
                                <span>{ this.props.corrAnaliseContabil }</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        );
    }

}

export default VMovCorrTable;

